export default class TaxesService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllTaxes(args) {
    return this.axiosIns.get(this.serviceConfig.taxes, { params: args });
  }

  createTaxes(args) {
    return this.axiosIns.post(this.serviceConfig.taxes, args);
  }

  getTaxes(id) {
    return this.axiosIns.get(`${this.serviceConfig.taxes}/${id}`);
  }

  editTaxes(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.taxes}/${id}`, args);
  }

  deleteTaxes(id) {
    return this.axiosIns.delete(`${this.serviceConfig.taxes}/${id}`);
  }
}
